export interface Translation {
  'en': string,
  'es-ES': string
}

export interface TranslationList {
  'en': string[],
  'es-ES': string[]
}

export interface Translations {
  [key: string]: Translation
}

export type Language = 'en' | 'es-ES'

export const unidadesTranslations: Translations = {
  'Universidade Estadual Paulista (Unesp)': { 
    'en': 'Sao Paulo State University (Unesp)',
    'es-ES': ''
  },
  'Instituto de Química': { 
    'en': 'Institute of Chemistry',
    'es-ES': ''
  },
  'Instituto de Geociências e Ciências Exatas': { 
    'en': 'Institute of Geosciences and Exact Sciences',
    'es-ES': ''
  },
  'Instituto de Ciência e Tecnologia': { 
    'en': 'Institute of Science and Technology',
    'es-ES': ''
  },
  'Instituto de Biociências, Letras e Ciências Exatas': { 
    'en': 'Institute of Biosciences, Humanities and Exact Sciences',
    'es-ES': ''
  },
  'Instituto de Biociências': { 
    'en': 'Institute of Biosciences',
    'es-ES': ''
  },
  'Instituto de Artes': { 
    'en': 'Institute of Arts',
    'es-ES': ''
  },
  'Faculdade de Odontologia': { 
    'en': 'School of Dentistry',
    'es-ES': ''
  },
  'Faculdade de Medicina Veterinária e Zootecnia': { 
    'en': 'School of Veterinary Medicine and Animal Science',
    'es-ES': ''
  },
  'Faculdade de Medicina Veterinária': { 
    'en': 'School of Veterinary Medicine',
    'es-ES': ''
  },
  'Faculdade de Medicina': { 
    'en': 'Medical School',
    'es-ES': ''
  },
  'Faculdade de Filosofia e Ciências': { 
    'en': 'School of Philosophy and Sciences',
    'es-ES': ''
  },
  'Faculdade de Engenharia': { 
    'en': 'School of Engineering',
    'es-ES': ''
  },
  'Faculdade de Ciências Humanas e Sociais': { 
    'en': 'School of Humanities and Social Sciences',
    'es-ES': ''
  },
  'Faculdade de Ciências Farmacêuticas': { 
    'en': 'School of Pharmaceutical Sciences',
    'es-ES': ''
  },
  'Faculdade de Ciências e Tecnologia': { 
    'en': 'School of Technology and Sciences',
    'es-ES': ''
  },
  'Faculdade de Ciências e Letras': { 
    'en': 'School of Humanities and Sciences',
    'es-ES': ''
  },
  'Faculdade de Ciências e Letras (Assis)': { 
    'en': 'School of Sciences, Humanities and Languages',
    'es-ES': ''
  },
  'Faculdade de Ciências e Engenharia': { 
    'en': 'School of Sciences and Engineering',
    'es-ES': ''
  },
  'Faculdade de Ciências Agronômicas': { 
    'en': 'School of Agriculture',
    'es-ES': ''
  },
  'Faculdade de Ciências Agrárias e Veterinárias': { 
    'en': 'School of Agricultural and Veterinarian Sciences',
    'es-ES': ''
  },
  'Faculdade de Ciências Agrárias e Tecnológicas': { 
    'en': 'College of Agricultural and Technological Sciences',
    'es-ES': ''
  },
  'Faculdade de Ciências': { 
    'en': 'School of Sciences',
    'es-ES': ''
  },
  'Faculdade de Arquitetura, Artes, Comunicação e Design': {
    'en': 'School of Architecture, Arts, Communication and Design',
    'es-ES': ''
  },
  'Instituto de Ciências e Engenharia': { 
    'en': 'Institute of Sciences and Engineering',
    'es-ES': ''
  },
  'Faculdade de Ciências, Tecnologia e Educação': { 
    'en': 'School of Technology, Sciences and Education',
    'es-ES': ''
  },
  'Faculdade de Ciências Agrárias do Vale do Ribeira': { 
    'en': 'School of Agricultural Sciences of Vale do Ribeira',
    'es-ES': ''
  },
  'Faculdade de Engenharia e Ciências': { 
    'en': 'School of Engineering and Sciences',
    'es-ES': ''
  },
  'Faculdade de Engenharia (SJBV)': { 
    'en': 'School of Engineering',
    'es-ES': ''
  },
  'Instituto de Física Teórica (IFT)': { 
    'en': 'Institute for Theoretical Physics (IFT)',
    'es-ES': ''
  },
  'Instituto de Pesquisas Meteorológicas (IPMet)': { 
    'en': 'Meteorological Research Institute (IPMet)',
    'es-ES': ''
  },
  'Centros de Estudos e Práticas Pedagógicas da Unesp': { 
    'en': 'Center of Studies and Pedagogical Practices',
    'es-ES': ''
  },
  'Instituto de Biotecnologia': { 
    'en': 'Institute for Biotechnology',
    'es-ES': ''
  },
  'Instituto de Estudos Avançados do Mar': { 
    'en': 'Institute for Advanced Studies of Ocean',
    'es-ES': ''
  },
  'Instituto de Pesquisa em Bioenergia': { 
    'en': 'Institute for Research in Bioenergy',
    'es-ES': ''
  },
  'Instituto de Políticas Públicas e Relações Internacionais': { 
    'en': 'Institute for Research on Public Policy and International Relations',
    'es-ES': ''
  },
  'Centro de Aquicultura': { 
    'en': 'Aquaculture Center',
    'es-ES': ''
  },
  'Centro de Estudos Ambientais': { 
    'en': 'Environmental Studies Center',
    'es-ES': ''
  },
  'Centro de Raízes e Amidos Tropicais': { 
    'en': 'Tropical Root and Starches Center',
    'es-ES': ''
  },
  'Centro de Estudos de Venenos e Animais Peçonhentos': { 
    'en': 'Venoms and Venomous Animals Center',
    'es-ES': ''
  },
  'Núcleo de Computação Científica (NCC)': { 
    'en': 'Center for Scientific Computing (NCC)',
    'es-ES': ''
  },
  'Centro de Meteorologia (IPMet)': { 
    'en': 'Center of Meteorology (IPMet)',
    'es-ES': ''
  }
}

export const titleTranslation: Translation = { 
  'en': 'UNESP Graduate Programs',
  'es-ES': 'Programas de posgrado de la UNESP'
}

export const descriptionTranslation: Translation = { 
  'en': 'Unesp is one of the public state universities of SP, alongside USP and Unicamp, with postgraduate programs, including master\'s and doctoral courses, accredited by Capes.',
  'es-ES': 'La Unesp es una de las universidades públicas estatales de SP, junto a la USP y la Unicamp, con programas de posgrado, incluyendo maestría y doctorado, acreditados por la Capes.'
}

export const areas: TranslationList = {
  'en': ['Agricultural Sciences', 'Biological Sciences', 'Health Sciences', 'Exact and Earth Sciences', 'Humanities', 'Engineering', 'Applied Social Sciences', 'Linguistics, Letters and Arts', 'Multidisciplinary'],
  'es-ES': ['Ciencias Agrícolas', 'Ciencias Biológicas', 'Ciencias de la salud', 'Ciencias exactas y de la tierra', 'Humanidades', 'Ingeniería', 'Ciencias Sociales Aplicadas', 'Lingüística, letras y artes', 'Multidisciplinaria']
}

export const niveis: TranslationList = {
  'en': ['Master', 'Professional Master', 'Doctorate', 'Professional Doctorate'],
  'es-ES': ['Maestría', 'Maestría Profesional', 'Doctorado', 'Doctorado Profesional']
}